import { DocumenterProgress, DocumenterRunState } from 'common/types/documenter'

export enum DocumenterActionTypes {
  RUN_PROGRESS = '@@documenter/RUN_PROGRESS',
  RUN_COMPLETED = '@@documenter/RUN_COMPLETED',
  RUN_FAILED = '@@documenter/RUN_FAILED',
  RUN_CLEARED = '@@documenter/RUN_CLEARED'
}

export interface DocumenterState {
  readonly runs: Record<string, DocumenterRunState>
}

export interface DocumenterRunProgressPayload {
  runId: string
  progress: DocumenterProgress
}

export interface DocumenterRunCompletedPayload {
  runId: string
  progress?: DocumenterProgress
}

export interface DocumenterRunFailedPayload {
  runId: string
  error: any
  progress?: DocumenterProgress
}

export interface DocumenterRunClearedPayload {
  runId: string
}
